<template>
    <div class="split-three">
        <dropdown
                className="day"
                :options="days"
                :selected="selectedDay"
                @updateOption="updateDay"
                :placeholder="'Dag'"
                :closeOnOutsideClick="true">
        </dropdown>
        <dropdown
                className="month"
                :options="months"
                :selected="selectedMonth"
                @updateOption="updateMonth"
                :placeholder="'Måned'"
                :closeOnOutsideClick="true">
        </dropdown>
        <dropdown
                className="year"
                :options="years"
                :selected="selectedYear"
                @updateOption="updateYear"
                :placeholder="'År'"
                :closeOnOutsideClick="true">
        </dropdown>
    </div>
</template>
<script>

    import Dropdown from "./Dropdown";

    export default {
        name: "DateSelector",
        components: {
            Dropdown,
        },
        props: [
            "value"
        ],
        data() {
            return {
                date: {
                    day: null,
                    month: null,
                    year: null,
                }
            }
        },
        computed: {
            selectedYear() {
                let t = this.years.find(y => y.id === this.date.year);
                return t ? t : {};
            },
            selectedMonth() {
                let t = this.months.find(y => y.id === this.date.month);
                return t ? t : {};
            },
            selectedDay() {
                let t = this.days.find(y => y.id === this.date.day);
                return t ? t : {};
            },
            days() {
                return Array.from({length: 31}, (v, k) => k + 1).map(d => {
                    return {
                        id: d, name: d
                    }
                });
            },
            months() {
                return [
                    'Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli',
                    'August', 'September', 'Oktober', 'November', 'Desember'
                ].map((m, i) => {
                    return {
                        id: i + 1,
                        name: m
                    }
                });
            },
            years() {
                let array = [];
                let date = new Date();
                for (let i = date.getFullYear() - 109; i < date.getFullYear() + 1; i++) {
                    array.push({id: i, name: i});
                }
                return array.reverse();
            }
        },
        watch: {
            value(val) {
                this.mapDate(val);
            },
            date: {
                deep: true,
                handler(newVal, oldVal) {

                    if (newVal.month !== null && newVal.year !== null && newVal.day !== null) {
                        let date = new Date(newVal.year, newVal.month - 1, newVal.day, 0, 0, 0, 0);
                        // If this date is valid, emit an input event that sets the value to this date
                        if (date && date.getDate() == newVal.day && date.getMonth() == newVal.month - 1 && date.getFullYear() == newVal.year) {
                            this.$emit("input", date);
                        } else {
                            // If however this date is invalid, ex 31. february 2020, we should emit an input event setting the value to null, so we can use validation on this field correctly.
                            this.$emit("input", null);
                            this.$emit("invalid-input", null);

                            // We should also reset the selection
                            this.date.day = null;
                            this.date.month = null;
                            this.date.year = null;
                        }
                    }
                }
            },
        },
        created() {
            if (this.value) {
                this.mapDate(new Date(this.value));
            }
        },
        methods: {
            mapDate(date) {
                this.date.year = date.getFullYear();
                this.date.month = date.getMonth() + 1;
                this.date.day = date.getDate();
            },
            updateDay(data) {
                this.date.day = data.id;
            },
            updateMonth(data) {
                this.date.month = data.id;
            },
            updateYear(data) {
                this.date.year = data.id;
            }
        }
    }
</script>